import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { ChangePasswordModel } from "../models/change-password-model.model";

@Injectable({ providedIn: "root" })
export class AccountService {
    private readonly httpClient = inject(HttpClient);

    public changeOrganization(orgId: string): Promise<void> {
        return firstValueFrom(this.httpClient.post<void>("/api/account/change", { orgId }));
    }

    public updatePassword(body: ChangePasswordModel): Promise<void> {
        return firstValueFrom(this.httpClient.put<void>("/api/account/password", body));
    }
}
